import React, { FC, useContext, useEffect, useState } from 'react';

import { Grid } from '@material-ui/core';

import { GlobalContext } from '../../../../../store';
import { IAdminClub } from '../../../../../store/admin/clubs/store';

import YesNoSwitch from '../../../../../components/YesNoSwitch';
import { useBoolean } from '../../../../common/Hooks/useBoolean.hook';
import { useRouteInfoState } from '../../../../../components/RouteInfo/Context/RouteInfo.context';
import SendNotificationForm from '../../../../../components/SendNotificationForm/SendNotificationForm';
import { CompleteEventStepStyled } from './CompleteEventStepStyled';

const CompleteEventStep: FC = () => {
  const { adminClubs } = useContext(GlobalContext);

  const { clubId, eventId } = useRouteInfoState();

  const [displaySendNotification, , setDisplaySendNotification] = useBoolean(false);

  const [club, setClub] = useState<IAdminClub>();

  useEffect(() => {
    if (adminClubs && clubId) {
      setClub(adminClubs.all[Number(clubId)]);
    }
  }, [clubId, adminClubs]);

  return (
    <CompleteEventStepStyled>
      <Grid container={true} spacing={2}>
        <Grid item={true} xs={3}>
          <h4>SEND A RECAP OF THE ROUND</h4>
        </Grid>

        <Grid item={true} xs={9}>
          <YesNoSwitch onChange={setDisplaySendNotification} />

          {displaySendNotification && club ? (
            <>
              <p>
                Message will be sent to the selectd group of players upon completion of the event
              </p>

              <SendNotificationForm club={club} eventId={eventId} />
            </>
          ) : (
            <div className="assign-awards">
              <div className="complete-event">
                <p>
                  Completing the event after all rounds are finished, scores are posted, and awards
                  are assigned. Head to the Standings & Leaderboard section to review or edit
                  results from this event after its completed.
                </p>

                <p>
                  All updates to the season standings will be posted after the event is competed.
                </p>
              </div>
            </div>
          )}
        </Grid>
      </Grid>
    </CompleteEventStepStyled>
  );
};

export default CompleteEventStep;
